
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/news",
      function () {
        return require("private-next-pages/node/news.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/news"])
      });
    }
  